import { Select } from "antd";
import React, { useState } from "react";
import { ChevronDown, ChevronUp, Filter } from "react-feather";
import CustomAutoComplete from "../../CommonComponents/CustomAutoComplete/CustomAutoComplete";

import "./stylesProvidersList.css";

function ProvidersList() {
  const [showExtraFilters, setShowExtraFilters] = useState(true);

  const casinoSelectorOptions = [
    {
      label: "Games",
      value: "games",
      options: [
        {
          value: "game1",
          label: "Game 1",
        },
        {
          value: "game2",
          label: "Game 2",
        },
        {
          value: "game3",
          label: "Game 3",
        },
      ],
    },
    {
      label: "Status",
      value: "status",
      options: [
        {
          value: "active",
          label: "Active",
        },
        {
          value: "inactive",
          label: "Inactive",
        },
      ],
    },
    {
      label: "Accepted bets",
      value: "acceptedBets",
      options: [
        {
          value: "accepted",
          label: "Accepted",
        },
        {
          value: "rejected",
          label: "Rejected",
        },
      ],
    },
    {
      label: "GGR",
      value: "ggr",
      options: [
        {
          value: "ggr1",
          label: "GGR 1",
        },
        {
          value: "ggr2",
          label: "GGR 2",
        },
        {
          value: "ggr3",
          label: "GGR 3",
        },
      ],
    },
    {
      label: "Turnover",
      value: "turnover",
      options: [
        {
          value: "turnover1",
          label: "Turnover 1",
        },
        {
          value: "turnover2",
          label: "Turnover 2",
        },
        {
          value: "turnover3",
          label: "Turnover 3",
        },
      ],
    },
    {
      label: "Margin",
      value: "margin",
      options: [
        {
          value: "margin1",
          label: "Margin 1",
        },
        {
          value: "margin2",
          label: "Margin 2",
        },
        {
          value: "margin3",
          label: "Margin 3",
        },
      ],
    },
    {
      label: "Net P/L",
      value: "netPL",
      options: [
        {
          value: "netPL1",
          label: "Net P/L 1",
        },
        {
          value: "netPL2",
          label: "Net P/L 2",
        },
        {
          value: "netPL3",
          label: "Net P/L 3",
        },
      ],
    },
    {
      label: "Total stake",
      value: "totalStake",
      options: [
        {
          value: "totalStake1",
          label: "Total Stake 1",
        },
        {
          value: "totalStake2",
          label: "Total Stake 2",
        },
        {
          value: "totalStake3",
          label: "Total Stake 3",
        },
      ],
    },
  ];

  const providers = [
    {
      value: "BGaming",
      label: "BGaming",
    },
    {
      value: "Booming",
      label: "Booming",
    },
    {
      value: "IMoon",
      label: "IMoon",
    },
    {
      value: "OddsChecker",
      label: "OddsChecker",
    },
    {
      value: "Action Network",
      label: "Action Network",
    },
    {
      value: "BetQL",
      label: "BetQL",
    },
  ];

  return (
    <div className="casino-content providers-list">
      <div className="casino-content-header">
        <div className="casino-autocomplete-container">
          <CustomAutoComplete
            placeholder="Search"
            allOptions={providers}
            handleChange={() => {}}
            clearOptions={() => {}}
          />
          <div className="divider"></div>
          <div
            className="filter-buttons"
            onClick={() => setShowExtraFilters(!showExtraFilters)}
          >
            <Filter className="filter-icon" />
            {showExtraFilters ? (
              <ChevronUp className="filter-icon" />
            ) : (
              <ChevronDown className="filter-icon" />
            )}
          </div>
        </div>
      </div>
      <div
        className="casino-selectors"
        style={{ display: showExtraFilters ? "flex" : "none" }}
      >
        {casinoSelectorOptions.map((option) => (
          <div className="casino-selector">
            <span>{option.label}</span>
            <Select
              mode="multiple"
              placeholder="Not Selected"
              onChange={() => {}}
              options={option.options}
            />
          </div>
        ))}
      </div>
      <div
        className="casino-selector-action-buttons"
        style={{ display: showExtraFilters ? "flex" : "none" }}
      >
        <button className="clear">Clear Filters</button>
        <button className="apply">Apply</button>
      </div>
    </div>
  );
}

export default ProvidersList;
